package streetlight.model.data

import kampfire.model.Labeled
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline
import kotlin.uuid.Uuid

//@Serializable
//sealed interface GalaxyPost: FeedEntity {
//}

@Serializable
@JvmInline
value class PostId(override val value: Uuid): RecordId {
    override fun toString() = value.toString()

    companion object {
        fun random() = PostId(Uuid.random())
    }
}

/** The orders a galaxy's feed can be sorted in. */
enum class PostOrder(label: String? = null): Labeled {
    New,
    Old,
    Lean;
    // Visibility;

    override val label = label ?: name
}

/** A post sharing a location. */
@Serializable
data class LocationPost(
    val location: Location,
    override val post: Post,
): Entity by location {
}

/** A post sharing an event. */
@Serializable
data class EventPost(
    val event: EventLocation,
    override val post: Post,
): Entity by event {
}

/** A post sharing media. */
@Serializable
data class MediaPost(
    val media: Media,
    override val post: Post,
): Entity by media {
}